module.exports = __webpack_public_path__ + "img/iconHistoryWeight.dcc1c11c.svg";